<script setup>

import { computed } from 'vue';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';

const { inbox } = defineProps({
  inbox: { type: Object, default: () => ({}) }, // note the ({})
})

const computedInboxStyle = computed(() => {
  const id = inbox?.id
  return [5, 9, 11, 13].includes(id) ? 'redinbox' : ''
})

</script>
<style> .redinbox{color:red;}</style>

<template>
  <div class="flex items-center text-n-slate-11 text-xs min-w-0">
    <ChannelIcon
      :inbox="inbox"
      class="size-3 ltr:mr-1 rtl:ml-1 flex-shrink-0"
    />
    <span class="truncate">
	    <strong :class="computedInboxStyle">{{ inbox.name }}</strong>
    </span>
  </div>
</template>
